@if (isAdmin) {
<sm-toolbar>
    <button pButton severity="warn" icon="fas fa-cog" label="Administration" (click)="adminClick()"></button>
    <button pButton severity="warn" icon="fas fa-head-side-cough" label="Abmeldungen" (click)="sickNotesClick()"></button>
    <p-select class="width200" id="year" [options]="years" [(ngModel)]="year" (onChange)="selectedYearChanged()">
    </p-select>
</sm-toolbar>
}
<p-card header="Bitte wählen Sie eine Klasse aus">
    @if (noSchoolType) {
    <p-message severity="warn">
        text="Sie sehen keine Klassen, weil ihr Benutzer keinem Schulzweig zugeordnet ist. Bitte wenden Sie sich an das
        Sekretariat!"></p-message>
    }
    @else {
    <app-school-class-list [schoolClasses]="schoolClasses" baseUrl="/enaio-certificates/class-registers/class-register" [isHalfYear]="isHalfYear"></app-school-class-list>
    }
</p-card>